import { ILocalFileDTO, LocalFileStatus } from "../../../libs/coreapi-dto/dirs/globalImportInvoices";

export const mapGridRowToLocalFile = (row: ISelectGridRow): ILocalFileDTO | null => {
    if (!row) return null;

    const getValue = (name: string): any => {
        const cell = row.cells?.find(c => c.propertyName === name);
        return cell?.value;
    };

    // statusOriginal — исходное значение enum, не подверженное переводу/translation в гриде
    const statusValue = getValue("statusOriginal") ?? getValue("status");
    return {
        fileName: getValue("fileName") ?? "",
        idContractorGlobal: getValue("idContractorGlobal") ?? "",
        contractorName: getValue("contractorName") ?? "",
        connectionString: getValue("connectionString") ?? "",
        idSupplierGlobal: getValue("idSupplierGlobal") ?? null,
        supplierName: getValue("supplierName") ?? "",
        idStoreGlobal: getValue("idStoreGlobal") ?? null,
        storeName: getValue("storeName") ?? "",
        supplierDocNum: getValue("supplierDocNum") ?? "",
        supplierDocDate: getValue("supplierDocDate") ?? null,
        idImportedInvoiceGlobal: getValue("idImportedInvoiceGlobal") ?? null,
        idInvoiceGlobal: getValue("idInvoiceGlobal") ?? null,
        status: (statusValue as LocalFileStatus) ?? LocalFileStatus.New,
        itemCount: getValue("itemCount") ?? null,
        sumIncVat: getValue("sumIncVat") ?? null,
        sumWithoutVat: getValue("sumWithoutVat") ?? null,
        vatSum: getValue("vatSum") ?? null
    };
};
